<div class="text-right-float">
  <h5>**A PBI must be created and assigned to anyone from DevOps Team for deploying new changes.**</h5>
</div>
<div class="env-selector-wrapper">
  <div class="env-selector-bar">
    <div class="env-selector-left">
      <mat-icon class="env-icon">dns</mat-icon>
      <span class="env-label">Target Environment</span>
    </div>
    <div class="env-selector-right">
      <mat-button-toggle-group [(ngModel)]="selectedStage" (change)="onEnvironmentChange()" aria-label="Target Environment" class="env-toggle-group">
        @for (s of stages; track s) {
          <mat-button-toggle [value]="s.value" [ngClass]="'env-toggle-' + s.cssClass">
            <mat-icon class="env-toggle-icon">{{ s.icon }}</mat-icon>
            {{ s.label }}
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
    </div>
  </div>
</div>
<div class="env-selector-wrapper">
    <div class="env-selector-bar">
        <div class="env-selector-left">
            <mat-icon class="env-icon">dns</mat-icon>
            <span class="env-label">Target Environment</span>
        </div>
        <div class="env-selector-right">
            <mat-button-toggle-group [(ngModel)]="selectedStage" (change)="onEnvironmentChange()" aria-label="Target Environment" class="env-toggle-group">
                <mat-button-toggle *ngFor="let s of stages" [value]="s.value" [ngClass]="'env-toggle-' + s.cssClass">
                    <mat-icon class="env-toggle-icon">{{ s.icon }}</mat-icon>
                    {{ s.label }}
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
    </div>
</div>
<div class="filter-container">
  <span class="bold-medium">Enable Auto Remote Reset commands for selected Controller Type</span>
  <button mat-icon-button (click)="toggleAutoRemoteReset()">
    <mat-icon [ngStyle]="{'color': autoRemoteReset.IsAutoRemoteResetEnabled ? '#7CFC00' : '#bdbdbd'}" class="toggle-icon">
      {{ autoRemoteReset.IsAutoRemoteResetEnabled ? 'toggle_on' : 'toggle_off' }}
    </mat-icon>
  </button>
  <h2 style="cursor:pointer; display:block;" class="flex-aligned-div" (click)="openLogsHistory()">
    Logs History
    <mat-icon data-html="true" style="color:white">info</mat-icon>
  </h2>
</div>
@if (autoRemoteReset.IsAutoRemoteResetEnabled) {
  <div>
    <mat-card class="card-margin">
      <mat-card-title class="card-title">
        Maximum Allowed Automatic Reset Executions
        <mat-icon class="icon-margin-cursor" matTooltip="Sets the maximum number of Auto Reset Cycles allowed per week. A full cycle includes executing all configured commands or ends when the unit returns to service">info</mat-icon>
      </mat-card-title>
      <mat-card-content>
        <table class="table-custom">
          <tr>
            <td class="text-right">
              <label class="label-margin">Maximum number of Automatic Reset Cycles per week</label>
            </td>
            <td style="text-align: left;">
              <mat-select id="maxResetPerWeek" [(ngModel)]="autoRemoteReset.MaximumExecutionsPerWeek" class="form-control select-width">
                @for (val of executionLimits; track val) {
                  <mat-option [value]="val">
                    {{val}}
                  </mat-option>
                }
              </mat-select>
            </td>
          </tr>
          <tr>
            <td class="text-right">
              <label class="label-margin">Maximum number of automatically executed Remote Resets commands per Day</label>
            </td>
            <td style="text-align: left;">
              <mat-select id="maxResetPerDay" [(ngModel)]="autoRemoteReset.MaximumExecutionsPerDay" class="form-control select-width">
                @for (val of executionLimits; track val) {
                  <mat-option [value]="val">
                    {{val}}
                  </mat-option>
                }
              </mat-select>
            </td>
          </tr>
          <tr>
            <td class="text-right">
              <label class="label-margin">Maximum number of automatically executed Remote Resets commands per Hour</label>
            </td>
            <td style="text-align: left;">
              <mat-select id="maxResetPerHour" [(ngModel)]="autoRemoteReset.MaximumExecutionsPerHour" class="form-control select-width">
                @for (val of executionLimits; track val) {
                  <mat-option [value]="val">
                    {{val}}
                  </mat-option>
                }
              </mat-select>
            </td>
          </tr>
        </table>
      </mat-card-content>
    </mat-card>
    <mat-card class="card-margin-bottom">
      <mat-card-title class="card-title card-title-white">
        Allowed times for Auto Reset Executions
        <mat-icon class="icon-margin-cursor" matTooltip="Specifies the time periods, based on the unit's local time, during which an Auto Remote Reset Cycle may be triggered. Days and times are configured separately, allowing definitions such as 'Monday to Friday between 20:00 and 21:00'">info</mat-icon>
      </mat-card-title>
      <mat-card-content>
        <mat-checkbox [(ngModel)]="alwaysAllowAutoReset" (change)="onAlwaysAllowAutoResetChange()" color="primary" class="custom-white-checkbox">
          Always allow Auto Reset
        </mat-checkbox>
        @if (!alwaysAllowAutoReset) {
          <div>
            @for (range of autoRemoteReset.ScheduleConfigurations; track range; let i = $index) {
              <div class="allowed-time-range">
                <table class="table-custom">
                  <tr>
                    <td class="text-right"><label>Start Day</label></td>
                    <td style="text-align: left;">
                      <mat-select [(ngModel)]="range.StartDayOfWeek" [name]="'startDay' + i" class="form-control select-width">
                        @for (day of daysOfWeek; track day) {
                          <mat-option [value]="day">{{day}}</mat-option>
                        }
                      </mat-select>
                    </td>
                    <td class="text-right"><label>End Day</label></td>
                    <td style="text-align: left;">
                      <mat-select [(ngModel)]="range.EndDayOfWeek" [name]="'endDay' + i" class="form-control select-width">
                        @for (day of daysOfWeek; track day) {
                          <mat-option [value]="day">{{day}}</mat-option>
                        }
                      </mat-select>
                    </td>
                    <td>
                      @if (autoRemoteReset.ScheduleConfigurations.length > 1) {
                        <button mat-icon-button color="warn" (click)="removeAllowedTimeRange(i)">
                          <mat-icon>remove_circle</mat-icon>
                        </button>
                      }
                    </td>
                  </tr>
                  <tr>
                    <td class="text-right"><label>Start Time [HH:mm]</label></td>
                    <td style="text-align: left;">
                      <mat-select [(ngModel)]="range.StartTime.hours" [name]="'startHour' + i" class="form-control select-width-small">
                        @for (h of hours; track h) {
                          <mat-option [value]="h">{{h < 10 ? '0' + h : h}}</mat-option>
                        }
                      </mat-select>
                      <span class="span-grey-bold"> : </span>
                      <mat-select [(ngModel)]="range.StartTime.minutes" [name]="'startMinute' + i" class="form-control select-width-small">
                        @for (m of minutes; track m) {
                          <mat-option [value]="m">{{m < 10 ? '0' + m : m}}</mat-option>
                        }
                      </mat-select>
                    </td>
                    <td class="text-right"><label>End Time [HH:mm]</label></td>
                    <td style="text-align: left;">
                      <mat-select [(ngModel)]="range.EndTime.hours" [name]="'endHour' + i" class="form-control select-width-small">
                        @for (h of hours; track h) {
                          <mat-option [value]="h">{{h < 10 ? '0' + h : h}}</mat-option>
                        }
                      </mat-select>
                      <span class="span-grey-bold"> : </span>
                      <mat-select [(ngModel)]="range.EndTime.minutes" [name]="'endMinute' + i" class="form-control select-width-small">
                        @for (m of minutes; track m) {
                          <mat-option [value]="m">{{m < 10 ? '0' + m : m}}</mat-option>
                        }
                      </mat-select>
                    </td>
                  </tr>
                </table>
              </div>
            }
            <button mat-icon-button color="primary" (click)="addAllowedTimeRange()">
              <mat-icon>add_circle</mat-icon>
              <span class="add-time-range-text">Add allowed time range</span>
            </button>
          </div>
        }
      </mat-card-content>
    </mat-card>
    <mat-card class="card-margin">
      <mat-card-title class="card-title">
        Auto Remote Reset Command Sequence
        <mat-icon class="icon-margin-cursor" matTooltip="Defines the sequence in which commands are executed during one Automatic Reset Cycle">info</mat-icon>
      </mat-card-title>
      <mat-card-content>
        <div class="div-flex-space">
          <div>
            <span class="add-command-label">Add new command</span>
            <button mat-icon-button (click)="openAddCommandDialog()" matTooltip="Add new command">
              <mat-icon>add_circle</mat-icon>
            </button>
          </div>
        </div>
        <table mat-table
          [dataSource]="dataSource"
          class="mat-elevation-z8 mat-table-custom" id="autoremoteresetlist">
          <!-- Sequence Column -->
          <ng-container matColumnDef="Sequence">
            <th mat-header-cell *matHeaderCellDef>Sequence</th>
            <td mat-cell *matCellDef="let element">{{element.SequenceId}}</td>
          </ng-container>
          <!-- CommandKey Column -->
          <ng-container matColumnDef="Command">
            <th mat-header-cell *matHeaderCellDef>Command</th>
            <td mat-cell *matCellDef="let element">
              {{ getCommandDescription(element.CommandKey) }}
            </td>
          </ng-container>
          <!-- Action Column -->
          <ng-container matColumnDef="Action">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let element">
              @if (!element.isEditing) {
                <button mat-button (click)="editRow(element)" matTooltip="Edit Row">
                  <mat-icon>edit</mat-icon>
                </button>
              }
              @if (element.isEditing) {
                <button mat-button color="primary" (click)="saveRow(element)" matTooltip="Edit Row">
                  <mat-icon>
                    edit
                  </mat-icon>
                </button>
              }
              @if (element.isEditing) {
                <button mat-icon-button (click)="cancelEdit(element)" matTooltip="Cancel Row">
                  <mat-icon>rotate_left</mat-icon>
                </button>
              }
              @if (!element.isEditing) {
                <button mat-icon-button matTooltip="Move Up" (click)="moveUp(element)">
                  <mat-icon>keyboard_arrow_up</mat-icon>
                </button>
              }
              @if (!element.isEditing) {
                <button mat-icon-button matTooltip="Move Down" (click)="moveDown(element)">
                  <mat-icon>keyboard_arrow_down</mat-icon>
                </button>
              }
              @if (element.isEditing) {
                <button mat-icon-button matTooltip="Delete Row" (click)="deleteRow(element)">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                <tr mat-row *matRowDef="let element; let i = dataIndex;
                columns: columnsToDisplay;"
            class="item"
            [class.alternative2]="element.isEditing">
          </tr>
        </table>
      </mat-card-content>
    </mat-card>
  </div>
}
<div class="center-flex-column">
  <button mat-raised-button
    [color]="hasUnsavedChanges() ? 'primary' : null"
    [disabled]="!hasUnsavedChanges()"
    [ngClass]="!hasUnsavedChanges() ? 'save-btn-disabled' : ''"
    (click)="saveAutoRemoteResetConfiguration()">
    Save All Changes
  </button>
</div>